import { render, staticRenderFns } from "./leave-apply.vue?vue&type=template&id=2b01d887&scoped=true"
import script from "./leave-apply.vue?vue&type=script&lang=js"
export * from "./leave-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01d887",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b01d887')) {
      api.createRecord('2b01d887', component.options)
    } else {
      api.reload('2b01d887', component.options)
    }
    module.hot.accept("./leave-apply.vue?vue&type=template&id=2b01d887&scoped=true", function () {
      api.rerender('2b01d887', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/office/leave/leave-apply.vue"
export default component.exports